import { Button, Icon } from 'semantic-ui-react';

const FlowBackButton = ({ onClick }) => {
  if (!onClick) return null;

  return (
    <Button type="button" className="flow-back" onClick={onClick}>
      <Icon name="arrow left" /> Atrás
    </Button>
  );
};

export default FlowBackButton;
